import * as $ from "jquery";
import { Util } from "./util";
import { Business } from "./business";
import { ModalBase } from "./base/base";

/** */
//#1273 SPAの基盤のインスタンスの保管場所を変更
//export class SPA {
class SPA {

    //private static ignore_key_elms = ["#userinfo, #header, #side-menu, #ribbon, #main, #footer, #shortcut, #divSmallBoxes, #divMiniIcons, #divbigBoxes, #voiceModal, script, .ui-chatbox, #sideMenuContextMenu, .hidden, #TccNotifyBoxes, #TccDtPicker, #tccToolTip, #ezcHint, .tcc-component.datepicker"];
    //private static ignore_key_elms = [];

    //#1298 grapecity関連の不要なelement（SPA実行時に残ってしまう）
    //private static forced_remove_elms_selectors = ['.gc-theme-version', '[gcuielement]', 'span[style="visibility: hidden; top: -10000px; left: -10000px; font: bold 14.6667px Calibri; position: absolute;"]'];
    //恒久対応
    private static forced_remove_elms_selectors = ['.gc-theme-version', '[gcuielement]', 'span[style*="visibility: hidden; top: -10000px; left: -10000px;"]'];

    private container: JQuery;

    currentPageUrl: string;

    onNavigate: (newPage, oldPage, pushStated: boolean) => void;

    /** */
    constructor(container: any) {
        this.container = $(container);
        this.init();
    }


    /** */
    init() {


        //////Legacy(URLhashを用いてうまいことやる場合)
        ////$(window).on("hashchange", (e) => {
        ////    this.navigate();
        ////})

        ////戻る・進むボタンがクリックされたとき
        //$(window).on('popstate', (e) => {
        //    //popstateイベントはcancellableではありません。 
        //    //https://developer.mozilla.org/en-US/docs/Web/API/Window/popstate_event
        //    //e.preventDefault();
        //    //popstateはstateがチェンジした後なので、topFrameのlocationが移動対象になる
        //    const page = spa.getLocation();
        //    const lastPage = spa.currentPageUrl;

        //    if (page) {
        //        //クリックしたリンク先のURLと現在のURLが一致する場合は処理を終える
        //        //historyの場合は、あっても良いかも
        //        //if (page === lastPage) { return; }
        //        ////移動
        //        //spa.navigate(page);
        //        SPIRIT.business.page.confirmClose((result) => {
        //            //移動
        //            if (result === "ok") {
        //                spa.navigate(page, false);
        //                this.normalize();
        //            } else {
        //                ////よって新しくエントリしてしまう
        //                //history.pushState(null, null, lastPage);
        //                //下記だと、「戻り」「進む」のあとのエントリの書き換えになるので、URLは書き換えになってくれるが履歴自体も書き変わってしまう(課題stateをうまく使うか？)
        //                history.replaceState(null, null, lastPage);
        //                //windowタブのタイトルが勝手に切り替わっている(メカニズムがわからんが)
        //                //よってDocumentのタイトルを再度設定しなおす(すると治る)
        //                const title = $('title').text();
        //                $('title').text(title);
        //            }
        //        });
        //    }
        //});


        this.currentPageUrl = this.getLocation();
    };


    /**
     * 現在のページ名を取得する
     **/
    getLocation() {
        //return location.pathname.split('/').pop();
        //return location.pathname;
        return location.pathname + (location.search || '');
    }

    /**
     * 
     * @param url
     * @param pushState
     */
    navigate(url: string, pushState?: boolean) {
        //const lastPage = this.getLocation();
        const lastPage = this.currentPageUrl;
        pushState = (pushState === false) ? false : true;

        let target = "";

        if (url) {

            ////クリックしたリンク先のURLと現在のURLが一致する場合は処理を終える
            //if (url === lastPage) {
            //    return;
            //}

            //新しい URLが、変更前のURLから hash のみを変更した URL である場合であっても、
            //pushState() は hashchange イベントを発火させることはないと注記しておきます。
            //history.pushState(null, null, url);

            if (pushState) {
                //history.pushState(lastPage, null, url);
                history.pushState(null, null, url);
            }

            target = url;
        } else {

            if (0 > location.href.indexOf("#", 0)) {
                target = location.pathname;
            } else {
                //"#"hashchangeで行うLegacyタイプを担保
                target = location.href.split("#").splice(1).join("#");
            }

            target = target + location.search;
        }



        //this.loadPage(target + location.search, $(this.container));//Legacy用


        //#1944 
        //this.loadPage(target, $(this.container));
        //this.currentPageUrl = url;
        //this.onNavigate?.call(this, this.currentPageUrl, lastPage);


        this.loadPage(target, $(this.container)).then(() => {
            this.currentPageUrl = url;
            this.onNavigate?.call(this, this.currentPageUrl, lastPage, pushState);

        }).catch((err) => {

        }).finally(() => {

        });

    };


    /**
     * 
     * @param url
     * @param container
     */
    async loadPage(url, container: JQuery) {

        //#1944 
        return new Promise((resolve, reject) => {
            try {
                if (container && container[0] != this.container[0]) {
                    this.container = $(container);
                }

                //クリーンアップ
                this.destroyScreen(this.container);

                Util.ajax({
                    url: url,
                    type: "GET",
                    dataType: "html",
                    cache: !0,

                    //CSRF対策の妨げになるので別で...
                    //beforeSend: function () {
                    //    //破棄する画面instannceを破棄する
                    //    const spirit = Business.page.pageInstance;
                    //    spirit?.destroy();
                    //    container.removeData().html("");
                    //    //下記のロジックは微妙！（有効にするとすべて消える）
                    //    //if (SPA.ignore_key_elms.length > 0) {
                    //    //    $("body").find("> *").filter(":not(" + SPA.ignore_key_elms + ")").empty().remove();
                    //    //}
                    //    //#1298 grapecity関連の不要なelement（SPA実行時に残ってしまう）
                    //    if (SPA.forced_remove_elms_selectors.length > 0) {
                    //        for (var i = 0; i < SPA.forced_remove_elms_selectors.length; i++) {
                    //            $("body").find(SPA.forced_remove_elms_selectors[i]).empty().remove();
                    //        }
                    //    }
                    //    //開いているモーダル(モードレスも)を消す
                    //    let $modals = $(ModalBase.INSTANCE_RETAINER).filter(':not(.' + ModalBase.CLASS_DO_NOT_RELEASE + ' )');
                    //    $modals.each((i, el) => {
                    //        let modal: ModalBase = $(el).data(ModalBase.DATA_KEY);
                    //        modal.destroy();
                    //    });
                    //    container.html('<h4 class=""><i class="fa fa-spin fa-cog animate__animated animate__fast"></i></h1>');
                    //    //container.html('<h4 class=""><i class="fa fa-spin fa-circle-notch animate__animated animate__fast"></i></h1>');
                    //    $("html").animate({ scrollTop: 0 }, "fast");
                    //}

                }).done((data, t, n) => {
                    let $data = $(data);
                    //「title」を切り替え
                    const title = $data.filter('title').text();
                    if (title) {
                        $('title').text(title);
                    }
                    //FullPageで送られた場合を考慮(<html>タグから始まるHTML文字列。その中から#body-containerの要素を取得し)
                    if ($data.find('#' + container.attr('id')).length > 0) {
                        $data = $data.find('#' + container.attr('id'));
                    };
                    this.container.off('animationend', this.animated);
                    this.container.on('animationend', this.animated);
                    this.container.addClass("animate__animated animate__fadeIn ");
                    this.container.html($data.html());
                    //pageSetUp(),
                    data = null;

                    resolve();

                }).fail((data, t, n) => {
                    reject({ data: data, ErrorStatus: t, message: n });
                });

            } catch (e) {
                reject(e);
            }

        });
    }


    /**
     * 画面(領域)をクリーンする
     */
    destroyScreen(container) {
        //破棄する画面instannceを破棄する
        const spirit = Business.page.pageInstance;
        spirit?.destroy();
        container.removeData().html("");

        //下記のロジックは微妙！（有効にするとすべて消える）
        //if (SPA.ignore_key_elms.length > 0) {
        //    $("body").find("> *").filter(":not(" + SPA.ignore_key_elms + ")").empty().remove();
        //}

        //#1298 grapecity関連の不要なelement（SPA実行時に残ってしまう）
        if (SPA.forced_remove_elms_selectors.length > 0) {
            for (var i = 0; i < SPA.forced_remove_elms_selectors.length; i++) {
                $("body").find(SPA.forced_remove_elms_selectors[i]).empty().remove();
            }
        }
        //開いているモーダル(モードレスも)を消す
        let $modals = $(ModalBase.INSTANCE_RETAINER).filter(':not(.' + ModalBase.CLASS_DO_NOT_RELEASE + ' )');
        $modals.each((i, el) => {
            let modal: ModalBase = $(el).data(ModalBase.DATA_KEY);
            modal?.destroy();
        });

        container.html('<h4 class=""><i class="fa fa-spin fa-cog animate__animated animate__fast"></i></h1>');
        //container.html('<h4 class=""><i class="fa fa-spin fa-circle-notch animate__animated animate__fast"></i></h1>');
        $("html").animate({ scrollTop: 0 }, "fast");

    }


    /** */
    private animated() {
        $(this).removeClass("animate__animated animate__fadeIn ");
    }
}


/** singleton */
export const _SPA = {
    /** */
    get instance(): SPA {
        //documentのdataに隠ぺいし、いつでも使用できるようにする
        let _spa: SPA = $(document).data('spa');
        if (!_spa) {
            _spa = new SPA($('#body-container'));
            $(document).data('spa', _spa);
        }
        return _spa;
    }
};
